var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8FacialRecognitionChecked50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2164_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.239563 26.6416H45.7604V43.4124H0.239563V26.6416Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0209 41.0168H2.63544V32.6313H5.03127V38.6209H11.0209V41.0168ZM43.3646 41.0168H34.9792V38.6209H40.9688V32.6313H43.3646V41.0168Z",
    fill: "#00B8D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3646 8.67301H40.9688V2.68343H34.9792V0.287598H43.3646V8.67301ZM5.03127 8.67301H2.63544V0.287598H11.0209V2.68343H5.03127V8.67301Z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1771 24.2459C36.1771 25.5636 35.099 26.6418 33.7813 26.6418C32.4636 26.6418 31.3854 25.5636 31.3854 24.2459C31.3854 22.9282 32.4636 21.8501 33.7813 21.8501C35.099 21.8501 36.1771 22.9282 36.1771 24.2459ZM14.6146 24.2459C14.6146 25.5636 13.5365 26.6418 12.2188 26.6418C10.9011 26.6418 9.82294 25.5636 9.82294 24.2459C9.82294 22.9282 10.9011 21.8501 12.2188 21.8501C13.5365 21.8501 14.6146 22.9282 14.6146 24.2459Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7812 17.0583C33.7812 7.95413 12.2188 11.0687 12.2188 17.0583V25.4437C12.2188 31.4333 17.0104 36.225 23 36.225C28.9896 36.225 33.7812 31.4333 33.7812 25.4437V17.0583Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.2771C15.6927 6.2771 11.0208 12.1469 11.0208 19.4542V22.2094L13.4166 24.2458V18.2563L27.7916 13.4646L32.5833 18.2563V24.2458L34.9791 22.2094V19.4542C34.9791 14.6625 33.7812 9.87085 27.7916 8.67293L26.5937 6.2771H23Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5938 24.2458C26.5938 24.9645 27.0729 25.4437 27.7917 25.4437C28.5104 25.4437 28.9896 24.9645 28.9896 24.2458C28.9896 23.527 28.5104 23.0479 27.7917 23.0479C27.0729 23.0479 26.5938 23.527 26.5938 24.2458ZM17.0104 24.2458C17.0104 24.9645 17.4896 25.4437 18.2084 25.4437C18.9271 25.4437 19.4063 24.9645 19.4063 24.2458C19.4063 23.527 18.9271 23.0479 18.2084 23.0479C17.4896 23.0479 17.0104 23.527 17.0104 24.2458Z",
    fill: "#784719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3386 26.6416C12.9375 32.0322 17.4896 36.2249 23 36.2249C28.5104 36.2249 33.0625 32.0322 33.6615 26.6416H12.3386Z",
    fill: "#00E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.239563 26.6416H45.7604V29.0374H0.239563V26.6416Z",
    fill: "#18FFFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2164_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8809 35.0001C49.8809 43.2181 43.218 49.881 35 49.881C26.782 49.881 20.119 43.2181 20.119 35.0001C20.119 26.7821 26.782 20.1191 35 20.1191C43.218 20.1191 49.8809 26.7821 49.8809 35.0001Z",
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8765 27.9956L32.7798 38.1042L28.6116 33.948L26.5074 36.0522L32.7827 42.3126L44.9814 30.0998L42.8765 27.9956Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2164_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 43.7,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2164_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8FacialRecognitionChecked50);
export default __webpack_public_path__ + "static/media/icons8-facial-recognition-checked-50.95f158a4048a1f2ad02bb62e061c30bd.svg";
export { ForwardRef as ReactComponent };